// Check that start time starts after 0s and is before end time
// Returns a valid number if either case fails
export const getValidatedStartTime = (startTime, endTime) => {
  let safeStartTime = Math.max(startTime, 0);
  safeStartTime = endTime ? Math.min(safeStartTime, endTime) : safeStartTime;
  return safeStartTime;
};

// Check that end time is before end of recording 0s and is after start time
// Returns a valid number if either case fails
export const getValidatedEndTime = (startTime, endTime, durationInSeconds) => {
  let safeEndTime = Math.min(endTime, durationInSeconds);
  safeEndTime = startTime ? Math.max(safeEndTime, startTime + 1) : safeEndTime;
  return safeEndTime;
};

// Returns whether or not end time is before the current time of mediaRef
export const isEndTimeBeforeCurrentTime = (mediaRef, endTime) => {
  if (mediaRef.current && mediaRef.current.currentTime > endTime) {
    return true;
  }
  return false;
};